import * as React from "react";

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-jm",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 320 240L0 480zm640 0L320 240l320 240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "m0 0 320 240L640 0zm0 480 320-240 320 240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M640 0h-59.6L0 435.3V480h59.6L640 44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 0v44.7L580.4 480H640v-44.7L59.6 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default ForwardRef;
export { ForwardRef as ReactComponent };